<script setup>
import { useStore } from 'vuex'
import { computed, watch, ref } from 'vue'

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  image: {
    type: String,
    default: ''
  },
  infobox: {
    type: String,
    default: ''
  },
  enabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['toggle'])

const store = useStore()
const infoboxes = computed(() => store.getters.getInfoboxes)

const currentInfobox = computed(() => {
  return infoboxes.value.find(item => item.id === props.infobox) || {}
})

// Track hover state and if user has left after disabling
const hasLeftAfterDisable = ref(true)
const isHovering = ref(false)

// Watch for enabled prop changes
watch(() => props.enabled, (newVal) => {
  if (newVal === false) {
    hasLeftAfterDisable.value = false
  }
})

const handleMouseEnter = () => {
  isHovering.value = true
}

const handleMouseLeave = () => {
  isHovering.value = false
  if (!props.enabled) {
    hasLeftAfterDisable.value = true
  }
}

const shouldShowHoverColor = computed(() => {
  return isHovering.value && (props.enabled || hasLeftAfterDisable.value)
})

const onMobile = ref(false)
const specsVisible = ref(false)
const hasGlowingInfoBtn = ref(false)
const hasGlowingCloseBtn = ref(false)

function specsBtnMouseOver() {
  hasGlowingInfoBtn.value = true;
}
function specsBtnMouseLeave(){
  hasGlowingInfoBtn.value = false;
}
function specsCloseBtnMouseOver() {
  hasGlowingCloseBtn.value = true;
}
function specsCloseBtnMouseLeave(){
  hasGlowingCloseBtn.value = false;
}
function enableAndHoldSpecs() {
  specsVisible.value = !specsVisible.value;
}
</script>

<template>
  <div class="container">
    <img 
      :src="image" 
      class="image" 
      :class="{ 
        active: enabled, 
        'hover-color': shouldShowHoverColor 
      }" 
      @click.stop="emit('toggle', !enabled)" 
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    >
    <label class="label">
      {{ label }}
    </label>
    <button 
      v-if="currentInfobox && currentInfobox.id"
      class="card-button-specs" 
      @mouseover="specsBtnMouseOver" 
      @mouseleave="specsBtnMouseLeave"
      @click.stop="enableAndHoldSpecs()"
    >
      <!-- <Transition name="glow">
        <div 
          v-show="hasGlowingInfoBtn"
          class="absolutepos glowinginfo"
        />
      </Transition> -->
      <div class="card-question-mark" style="pointer-events: none;">?</div>
      <h3 class="card-button-specs-text">
        Meer info
      </h3>
    </button>

    <Teleport to="body">
    <Transition name="fade">
      <div
        v-show="specsVisible"
        id="fullcover"
        @click="specsVisible = false"
      >              
        <div 
          :class="onMobile ? 'modalspecs modalspecs-size-mobile' : 'modalspecs modalspecs-size'"
          @click.stop=""
        >
          <div class="modaltopcontainer">
            <h3>
              {{ currentInfobox.title }}
            </h3>
            <button 
              class="modalclosebutton" 
              @mouseover="specsCloseBtnMouseOver" 
              @mouseleave="specsCloseBtnMouseLeave"
              @click="specsVisible = false"
            >
              <Transition name="closebtn">
                <div 
                  v-show="hasGlowingCloseBtn"
                  class="absolutepos glowingclose"
                />
              </Transition>
              <div>
                ×
              </div>
            </button>
          </div>
          <!-- <div class="greyheader"> 
            {{ data.infobox.header }}
          </div> -->
          <div class="imagescroller">
            <img class="modalimage" :src="`/infoboximages/${currentInfobox.urlEnding}`" alt="">
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
  </div>
</template>

<style lang="scss" scoped>
.container {
  width: auto;
  overflow: hidden;
  line-height: 16px;
}
.image {
  aspect-ratio: 1 / 1;
  width: calc(100% - 8px);
  height: auto;
  object-fit: cover;
  border: 2px solid #E2E8F0;
  box-sizing: border-box;
  border-radius: 8px;
  transition: border-color 0.1s ease;
  cursor: pointer;
}

// Remove the general hover state
// .image:hover {
//   cursor: pointer;
//   border-color: #BABC16;
// }

// Add specific hover class
.image.hover-color {
  border-color: #BABC16;
}

.label {
  font-size: 14px;
  line-height: 16px;
  padding: 4px;
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  color: #4A5568
}
.active {
  border-width: 4px;
  border-color: #BABC16;
}

.card {
  &-button-specs {
    cursor: pointer;
    margin: 0px auto;
    display: flex;
    align-items: center;
    flex-direction: row;
    // position: absolute;
    margin-top: 4px;
    height: 23px;
    right: 0;
    padding: 3px;
    border-radius: $radius-l;
    border-style: none;
    background-color: $c-secondary; // babc16
    color: white; //$c-secondary-text;

    &-text {
      font-size: 0.8rem;
      padding: 0px 8px;
      padding-right: 16px;
      font-family: 'Source Sans 3', sans-serif;
    }
  }

  &-question-mark {
    // padding: 5px 10px;
    padding: 0px 5px;
    border-radius: $radius-l;
    font-weight: bold;
    font-size: 0.7rem;    
    color: white;
    background-color: $c-primary;
  }
}




#fullcover {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modalspecs {
  position: fixed;
  z-index: 999;
  // top: 10%;
  left: 50%;
  // width: 30rem;
  // margin-left: -15rem;
  // height: 80vh;
  background-color: white;
  border-radius: 8px;
}
.modalspecs-size {
    top: 3%;
    width: 36rem;
    margin-left: -18rem;
    height: 94vh;
 }
.modalspecs-size-mobile {
    top: 10%;
    width: 98%;
    margin-left: -49%;
    height: 80vh;
 }

.modaltopcontainer {
  display: flex; text-align: start; height: 8vh
}
.modaltopcontainer h3 {
  margin: 1.5vh 1.5vh 1.5vh 3vh;
}
// .greyheader {
//   color: $c-secondary;
//   background-color: $c-primary; 
//   border-radius: 5px; 
//   margin: 0px 10px 10px 10px; 
//   font-size: x-large;
//   text-align: center; 
// }

.imagescroller {
  // max-height: calc(85% - 1px); // a trick to force a scroll area to appear despite fixed position
  max-height: calc(98% - 8vh); // minus size of modaltopcontainer
  overflow-y: auto;
}
.modalimage {
  width: 100%;
  height: auto;
}

.modalclosebutton {
  position: relative;
  // margin-left: auto;
  margin: 1.5vh 1.5vh 1.5vh auto;
  height: 4vh;
  width: 4vh;
  background: lightgrey;
  border: none;
  border-radius: 3vh;
  // padding: 0px 10px 0px 10px;
  font-size: 3vh;
  pointer-events: all;
  cursor: pointer;
  // force the × to stay centered despite resizing
  display: flex;
  align-items: center;
  justify-content: center;
}

.absolutepos {
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%;
}
.glowinginfo {
  background-color: rgba(255, 255, 255, 0.3);
}
.glowingclose {
  background-color: rgba(255, 255, 15, 0.75);
  border-radius: 20px;
}

.button-wrapper {
  border: none;
  display: flex;
  margin: 0px;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
  height: 200px;
}

// vue fade-in with <Transition>
// .fade-anim-enter-active,
// .fade-anim-leave-active {
//   transition: opacity 0.5s;
// }
// .fade-anim-enter, .fade-anim-leave-to {
//   opacity: 0;
// }
.fade-enter-active,
.fade-enter {
    transition: opacity 250ms ease;
}
.fade-leave-active {
    transition: opacity 0.5s ease;
}
.fade-leave-to, .fade-enter-from {
    opacity: 0;
}

.glow-enter-active,
.glow-enter {
    transition: opacity 0.5s ease;
}
.glow-leave-active {
    transition: opacity 0.5s ease;
}
.glow-leave-to, .fade-enter-from {
    opacity: 0;
}

.closebtn-enter-active,
.closebtn-enter {
    transition: opacity 0.5s ease;
}
.closebtn-leave-active {
    transition: opacity 0.5s ease;
}
.closebtn-leave-to, .fade-enter-from {
    opacity: 0;
}
</style>